<template>
    <div>
        <subLibraryDetails v-if="showPageType==1" :visible="showPageType==1"
                           :subLibraryDetailInfo="subLibraryDetailInfo" @goBackList="goBackList"/>
        <costAnalysisComponent v-show="showPageType==2" :visible="showPageType==2"
                               :subLibraryDetailInfo="subLibraryDetailInfo" :isUser="false" @goBackList="goBackList"/>
        <div v-show="showPageType == 0">
            <el-form ref="form" :inline="true" class="query-form" size="mini">
<!--                <el-form-item class="query-form-item">-->
<!--                    <el-form-item label="名称:" class="query-form-item">-->
<!--                        <el-input style="width: 150px;" clearable v-model="query.name"-->
<!--                                  placeholder="请输入名称"></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item label="采购人员：" class="query-form-item">-->
<!--                        <el-select v-model="query.developer_id" placeholder="状态" size="mini">-->
<!--                            <el-option label="全部" value=""></el-option>-->
<!--                            <el-option :label="item.full_name" :value="item.id"-->
<!--                                       v-for="item in managerAnalysisList"></el-option>-->
<!--                        </el-select>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item label="国家: " class="query-form-item" prop="state">-->
<!--                        <el-select v-model="query.state" style="width: 150px;" size="mini" filterable>-->
<!--                            <el-option v-for="item in us_arr" :key="item.us" :label="item.title" :value="item.us"-->
<!--                                       :disabled="item.disabled">-->
<!--                                <div class="keywords_arr_div">-->
<!--                                    <icon-svg :icon-class="item.us.toUpperCase()"-->
<!--                                              style="font-size: 24px;margin-right:5px;"></icon-svg>-->
<!--                                    <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{-->
<!--                                            item.title-->
<!--                                        }}</span>-->
<!--                                </div>-->
<!--                            </el-option>-->
<!--                        </el-select>-->
<!--                    </el-form-item>-->
<!--                    <el-button type="primary" @click="onSubmit">查询</el-button>-->
<!--                    <el-button type="primary" @click="onReset">重置</el-button>-->
<!--                    &lt;!&ndash;                    <el-button type="primary" @click="categoryList">根类目列表</el-button>&ndash;&gt;-->
<!--                    <el-button type="primary" @click="addSubLibrary" v-show="showAdd">添加</el-button>-->
<!--                    &lt;!&ndash;                    <el-button type="primary" @click="upadteRanking">更新情况</el-button>&ndash;&gt;-->
<!--                </el-form-item>-->
            </el-form>
            <el-table v-loading="loading" :data="list" :height="tableHeight" size="mini" ref="multipleTable"
                      @row-click="clickRowHandle" @header-click="clickHeaderHandle"
                      @selection-change="handleSelectionChange"
                      class="table_content mini_div" border @sort-change="handleSortChange" style="width: 100%;">

                <el-table-column
                    label="用户id"
                    align="center"
                    width="80">
                    <template slot-scope="scope">
                        <span>{{ scope.row.id }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="用户账号">
                    <template slot-scope="scope">
                        <span>{{ scope.row.username }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="用户名">
                    <template slot-scope="scope">
                        <span>{{ scope.row.full_name }}</span>
                    </template>
                </el-table-column>

                <el-table-column label="成本分析详情" width="180" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button style="margin: 5px 0 5px 10px" type="success" size="mini" v-show="showDetail"
                                   @click="seeDetail(scope.row)">进入
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :page-size="query.limit" :current-page="query.page"
                           :page-sizes="[20, 50, 100]" :total="query.total" background
                           style="float: right;margin-top: 10px;"
                           layout="total, sizes, prev, pager, next">
            </el-pagination>
        </div>

        <child-info-modal :visible="ctrl.childInfoVisible" :info="childInfo"
                          @close-callback="closeCllback"></child-info-modal>
        <addBid
            :visible="showAddRecord"
            :title="editType == 0 ?'添加爬取排名Asin任务' : '修改爬取排名Asin任务'"
            :copyData="copyData"
            :editType='editType'
            @close-callback="closeCllback"
        ></addBid>

        <el-dialog style="padding: 0 20px 20px 20px !important;" width="30%" center title="错误信息"
                   v-if="errorInfoShow"
                   :visible.sync="errorInfoShow">
            <span style="color: red">错误内容：</span>
            <span>{{ errorMsg }}</span>
            <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="errorInfoShow = false">关 闭</el-button>
			</span>
        </el-dialog>
        <basic-configuration-data :visible="showBasicConfigDataModal" v-if="showBasicConfigDataModal"
                                  @close-callback="showBasicConfigDataModal=false"></basic-configuration-data>
        <categoryList :visible="showCategoryList" v-if="showCategoryList"
                      @close-callback="showCategoryList=false"></categoryList>
        <addParse :visible="showAddParseModal" v-if="showAddParseModal" @close-callback="closeCllback"></addParse>
        <addSubLibrary :visible="addSubLibraryModal" @close-callback="closeCllback"/>
        <updateRankingModal :visible="upadteRankingModal" :subLibraryDetailInfo="subLibraryDetailInfo"
                            @close-callback="closeCllback"/>
        <peopleList :visible="peopleListVisible" @close-callback="peopleListVisible=false"
                    :subLibraryDetailInfo="subLibraryDetailInfo"></peopleList>
        <chooseDevelopModal ref="chooseDevelopModal"></chooseDevelopModal>
        <choose-develop-modal1 :visible="peopleListVisible1" @close-callback="closeCllback"
                               :subLibraryDetailInfo="subLibraryDetailInfo"></choose-develop-modal1>
    </div>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import addBid from './addBid.vue'
import {downloadFileUrl} from '@/utils/method'
import BasicConfigurationData from './basicConfigurationData.vue'
import categoryList from './categoryList.vue'
import addParse from './addPrase.vue'
import ChildInfoModal from './childInfoModal.vue'
import subLibraryDetails from './subLibraryDetails.vue'
import addSubLibrary from './addSubLibrary.vue'
import updateRankingModal from './updateRankingModal.vue'
import peopleList from './peopleList.vue'
import costAnalysisComponent from './costAnalysisComponent.vue'
import chooseDevelopModal from './chooseDevelopModal.vue'
import chooseDevelopModal1 from './chooseDevelopModal1.vue'
import {manager_build_selection_deleted, master_index_manager_lists} from '@/api/advAnalys/advAnalys.js'

let timer = null
export default {
    components: {
        ChildInfoModal,
        BasicConfigurationData,
        addBid,
        categoryList,
        addParse,
        subLibraryDetails,
        addSubLibrary,
        updateRankingModal,
        peopleList,
        costAnalysisComponent,
        chooseDevelopModal,
        chooseDevelopModal1,
    },
    data() {
        return {
            managerAnalysisList: [],
            rootCategoryList: [],
            usList: [],
            ukList: [],
            deList: [],
            imgStatusList: [
                {name: '全部', value: undefined},
                {name: '搜索不到图片', value: 1},
                {name: '暂无图片', value: 2},
                {name: '有图片', value: 3},
            ],
            isFold: true,
            editType: 0,
            copyData: {},
            manualRootShow: false,
            showBasicConfigDataModal: false,
            peopleListVisible: false,
            peopleListVisible1: false,
            showAddParseModal: false,
            showCategoryList: false,
            manualRootList: [],
            showAddRecord: false,
            currentId: '',
            tableHeight: null,
            errorMsg: '',
            errorInfoShow: false,
            ctrl: {
                DownloadListDialogVisible: false,
                uploadDialogVisible: false,
                bidDialogVisible: false,
                childInfoVisible: false,
            },
            typeArr: [{
                index: 1,
                title: '广告层面'
            },
                {
                    index: 2,
                    title: '逻辑层面'
                }
            ],
            query: {
                name: '',
                state: '',
                developer_id: '',
                page: 1,
                limit: 20,
                total: 0,
            },
            record_id: 0,
            activeName: 'antiInternal',
            list: [],
            disabled: false,
            listDisabled: false,
            loading: false,
            parseStatusList: [],
            updateData: {},
            childInfo: {},
            multipleSelection: [],
            subLibraryDetailInfo: {},
            showPageType: 0,
            addSubLibraryModal: false,
            upadteRankingModal: false,
        }
    },
    computed: {
        showDetail() {
            return this.$checkPermission('admin/master/index/manager_cost_analysis_details')
        },
    },
    created() {
        this.getManagerAnalysisList()
        this.getList()
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
        const that = this
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == 'object') {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight
                }
            })()
        }
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val
        }
    },
    destroyed() {
        clearInterval(timer)
    },
    methods: {
        openModal(arr) {
            if (arr.length) {
                this.$refs.chooseDevelopModal.visible = true
                this.$refs.chooseDevelopModal.list = arr
            }
        },
        seeDetail(data) {
            this.subLibraryDetailInfo = data
            this.showPageType = 1
        },
        costAnalysis(data) {
            this.subLibraryDetailInfo = data
            this.showPageType = 2
        },
        handleSelectionChange(val) {
            let arr = []
            val.map(v => {
                arr.push(v.id)
            })
            arr = Array.from(new Set(arr))
            this.multipleSelection = arr
        },
        seeUrl(row) {
            this.childInfo.title = '1688链接'
            this.childInfo.info = row.href_link
            this.ctrl.childInfoVisible = true
        },
        jumpUrl(row) {
            if (Array.isArray(row.skip_href_link) && row.skip_href_link.length > 0) {
                window.open(row.skip_href_link[0], '_blank')
            } else {
                this.$message.warning('没有链接')
            }
        },
        //跳转到亚马逊产品页面
        edirectToAsin(data) {
            // let url =
            //     link_us(data.state) +
            //     'dp/' +
            //     data.url_asin_href +
            //     '?th=1&psc=1'
            window.open(data.href_link, '_blank')
        },
        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },
        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },
        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },

        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },

        spanMethod({row, column, rowIndex, columnIndex}) {

            const columns = [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]
            if (rowIndex % 3 == 0) {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 3,
                    colspan: 1
                }
            } else {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 0,
                    colspan: 0
                }
            }
        },
        addDataFunc() {
            this.editType = 0
            this.showAddRecord = true
        },
        copyDataFunc(data, type) {
            this.showAddRecord = true
            let tempDate = JSON.parse(JSON.stringify(data))
            tempDate.is_peak_season = tempDate.is_peak_season == 1 ? true : false
            tempDate.is_seasonality = tempDate.is_seasonality == 1 ? true : false
            this.editType = type
            this.copyData = tempDate
        },
        delete_records(data) {
            this.$confirm('确认删除该分库吗?', '提示', {
                type: 'warning'
            }).then(() => {
                api.manager_build_selection_deleted({id: data.id}).then(() => {
                    this.$message.success('删除成功')
                    this.getList()
                })
            })
        },
        update_records(data) {
            api.branch_warehouse_line_update_link({id: data.id}).then((res) => {
                if (res.success) {
                    this.$message.success('更新中')
                    this.getList()
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(res => {
                this.$message({type: 'error', message: res.message})
            })
        },
        getUpdateStatus(data) {
            api.branch_warehouse_line_get_update_status({id: data.id}).then((res) => {
                const h = this.$createElement
                this.$notify({
                    title: '提示',
                    message: h('i', {style: 'color: teal'}, res.data || ''),
                    duration: 5000
                })

            }).catch(res => {
                this.$message({type: 'error', message: res.message})
            })
        },
        getPeaple_records(data) {
            this.subLibraryDetailInfo = data
            this.peopleListVisible1 = true
        },
        showErrorInfo(info) {
            this.errorInfoShow = true
            this.errorMsg = info.alibaba_err_msg
        },
        showManualRoot(info) {
            this.manualRootShow = true
            this.manualRootList = info
        },
        getManagerAnalysisList() {
            api.manager_index_get_developer_list().then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = res.data || []
                    this.managerAnalysisList = responseList
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        getList() {
            this.loading = true
            api.master_index_manager_lists(this.query).then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = res.data.list || []
                    this.list = responseList
                    this.query.total = res.data.total
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        clickRowHandle(row, column) {
            if (['标题', '类目树', '子类目', '颜色'].includes(column.label)) {
                this.childInfo.title = column.label
                let info = row.title
                if (column.label == '类目树') {
                    info = row.categoryTree
                } else if (column.label == '子类目') {
                    info = row.categories_str
                } else if (column.label == '颜色') {
                    info = row.color
                }
                this.childInfo.info = info
                this.ctrl.childInfoVisible = true
            }
            if (['折叠', '收起'].includes(column.label)) {
                this.isFold = !this.isFold
            }
        },
        clickHeaderHandle(row, column) {
            if (['折叠', '收起'].includes(row.label)) {
                this.isFold = !this.isFold
            }
        },
        handleSortChange(val) {
            if (val.order == 'ascending') {
                this.query.desc = 'desc'
                this.query.order = val.prop
            } else if (val.order == 'descending') {
                this.query.desc = 'asc'
                this.query.order = val.prop
            }
            this.getList()
        },
        handleClick(tab) {
            this.$nextTick(() => {
                this.$refs[tab.paneName].getList()
            })
        },
        //重置
        onReset() {
            this.query = {
                name: '',
                state: '',
                developer_id: '',
                page: 1,
                limit: 20,
                total: 0,
            }
            this.getList()
        },
        //查询
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        basicData() {
            this.showBasicConfigDataModal = true
        },
        addParse() {
            this.showAddParseModal = true
        },
        // 批量删除
        batchDelete() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量删除已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_delete({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '删除成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        // 批量重置
        batchReset() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量重置已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_batch_reset({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '重置成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        // 类目列表
        categoryList() {
            this.showCategoryList = true
        },
        addSubLibrary() {
            this.addSubLibraryModal = true
        },
        upadteRanking() {
            this.upadteRankingModal = true
        },
        change() {
            this.getList()
        },
        clearValue() {
            this.query.state = ''
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        //上传文件
        onupload() {
            this.ctrl.uploadDialogVisible = true
        },
        //下载列表
        onDownloadList() {
            this.ctrl.DownloadListDialogVisible = true
            this.$nextTick(() => {
                this.$refs[this.activeName].getList()
            })
        },
        // bid记录列表
        openBidList(data) {
            this.currentId = data.id
            this.ctrl.bidDialogVisible = true
        },
        async startDecode(row, force = 0) {
            if (force) {
                await this.$confirm('是否重新运行解析任务', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
            }
            let list = JSON.parse(JSON.stringify(this.list))
            api.variety_cost_control_analysis_parsing_file({
                id: row.id,
                force
            }).then(() => {
                const index = list.findIndex(item => item.id === row.id)
                list[index].status = 1
                this.list = list
            })
        },
        toMeFunc() {
            this.peopleListVisible = true
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        //添加广告优化记录
        onAddPpc(data) {
            this.record_id = data.id
            this.ctrl.addPpcDialogVisible = true
        },
        // 关闭弹窗回调
        closeCllback(isShow) {
            this.showAddRecord = false
            this.peopleListVisible1 = false
            this.showAddParseModal = false
            this.ctrl.childInfoVisible = false
            this.showPageType = 0
            this.addSubLibraryModal = false
            this.upadteRankingModal = false
            this.updateData = {}
            isShow == true && this.getList()
        },
        goBackList() {
            this.showPageType = 0
        },
        update(data) {
            this.updateData = data
            this.showAddRecord = true
        }
    }
}
</script>

<style type="text/scss" lang="scss" scoped>
.redTxt {
    color: red;
    font-weight: bold;
}

.fixedHeight {
    height: 30px;
    line-height: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mini_div .el-button--mini {
    padding: 5px 5px !important;
}

/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
